import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import {onMounted, ref} from "vue";
	import {FetchData} from "../utils/FetchData";
	import TeamCard from '../components/TeamCard.vue';
	import FetchOptions from "../interfaces/FetchOptions";
	import ModalWindow from '../components/ModalWindow.vue';
	import LoadingCircleAnimation from '../components/LoadingCircleAnimation.vue';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'TeamsPage',
  setup(__props) {

	const teams = ref([]);
	const deletingTeam = ref({});
	const modalVisible = ref(false);
	const loading = ref(true);

	onMounted(() => {
		RetrieveTeams();
	});

	async function RetrieveTeams() {
		const data = await FetchData('teams');
		if(!data.isError)
			teams.value = data.data;

		loading.value = false;
	}

	function addTeam() {
		teams.value.unshift({});
	}

	function onDeleteTeam(team: object) {
		if(team.id == undefined) {
			teams.value.shift();
			return;
		}

		modalVisible.value = true;
		deletingTeam.value = team;
	}

	async function confirmAccept() {
		modalVisible.value = false;

		const options: FetchOptions = {
			method: 'DELETE'
		};
		const data = await FetchData("teams/" + deletingTeam.value.id, options);
		if(!data.isError)
			teams.value = teams.value.filter(x => x.id != deletingTeam.value.id);
	}

	function confirmDeny() {
		modalVisible.value = false;
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "content-box",
      onClick: addTeam
    }, " Team toevoegen "),
    (!loading.value)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(teams.value, (team) => {
          return (_openBlock(), _createBlock(TeamCard, {
            key: team,
            team: team,
            onDeleteTeam: onDeleteTeam
          }, null, 8, ["team"]))
        }), 128))
      : (loading.value)
        ? (_openBlock(), _createBlock(LoadingCircleAnimation, { key: 1 }))
        : _createCommentVNode("", true),
    _withDirectives(_createVNode(ModalWindow, null, {
      header: _withCtx(() => [
        _createTextVNode(" Bevestigen ")
      ]),
      content: _withCtx(() => [
        _createTextVNode(" Je staat op het punt om het team '" + _toDisplayString(deletingTeam.value.name) + "' te verwijderen. Dit zal ook alle coureurs die er mee verbonden zijn ook verwijderen. ", 1),
        _hoisted_1,
        _hoisted_2,
        _createTextVNode(" Doorgaan met verwijderen? ")
      ]),
      buttons: _withCtx(() => [
        _createElementVNode("button", { onClick: confirmAccept }, "Ja"),
        _createElementVNode("button", { onClick: confirmDeny }, "Nee")
      ]),
      _: 1
    }, 512), [
      [_vShow, modalVisible.value]
    ])
  ], 64))
}
}

})